import React from "react";
import monitorError from "../../assets/img/erro.svg";
import { goHome, disableInteraction } from "./ModalFunctions";
import "./ErrorModal.css";

const ErrorModal = () => {
  disableInteraction();

  return (
    <div className="show modal">
      <div className="modal-info">
        {/* <img className="modal-image" src={monitorError} alt="error" /> */}
        <h3>Ops, algo deu errado.</h3>
        <div className="action-buttons">
        {!window.location.href.includes('home') && (
          <button
            className="modal-button-initial-page"
            onClick={() => goHome()}
          >
            Página Inicial
          </button>
          )}
          <button
            className="modal-button-reload"
            onClick={() => window.location.reload()}
          >
            Recarregar
          </button>
        </div>
      </div>
    </div>
  );
};
export default ErrorModal;



// WEBPACK FOOTER //
// ./src/components/Modal/ErrorModal.jsx